"use client";
import {
  LittleText,
  MediumText,
  NotificationText,
  TextBody,
} from "../typography";
import triangleUpIcon from "../../assets/images/icons/triangle-up-icon.svg";
import triangleDownIcon from "../../assets/images/icons/triangle-down-icon.svg";
import arrowUpIcon from "../../assets/images/icons/arrow-up-icon.svg";
import arrowDownIcon from "../../assets/images/icons/arrow-down-icon.svg";
import styled from "styled-components";
import { COLORS } from "../../assets/utils/enums/colors";
import { useEffect, useRef, useState } from "react";
import { useOutsideClick } from "../../assets/utils/hooks/useOutsideClick";
import { panelItems } from "../../assets/utils/data/panel-items";
import { langs } from "../../assets/utils/data/langs";
import earthIcon from "../../assets/images/icons/earth-outline-icon.svg";
import { DropdownTypeEnum } from "../../assets/utils/enums/table";
import {
  CurrencyType,
  EndpointsEnum,
  NameIdType,
  periodsObj,
  PeriodTypesEnum,
  StageEnum,
  stagesObj,
} from "../../assets/utils/enums/project";
import { Button } from "./button";
import getData from "../../api/project-request";
import DropdownDataItem, { DropdownButtonItem } from "./dropdown-item";
import {
  API_URL_FINANCE,
  API_URL_PROJECT,
  API_URL_SELLING,
  API_URL_VALUTA,
} from "../../constants";
import { FinanceTypeTable } from "../../assets/utils/enums/finance";
import { useNavigate } from "react-router-dom";
import { SellingStage, sellingStagesObj } from "../../assets/utils/enums/selling";

export default function Dropdown({
  checkedValue,
  setChecked,
  type,
  numberArray,
  contactsArr,
  companyArr,
  item,
  setItem,
  itemsNameIdArr,
  placeholder,
  financeTableType,
}: {
  checkedValue: string;
  setChecked: React.Dispatch<React.SetStateAction<string>>;
  type: DropdownTypeEnum;
  numberArray?: any[];
  contactsArr?: { fullName: string; email: string }[];
  companyArr?: { id: number; name: string; responsibleEmail: string }[];
  item?: NameIdType;
  setItem?: React.Dispatch<React.SetStateAction<NameIdType>>;
  itemsNameIdArr?: NameIdType[];
  placeholder?: string;
  financeTableType?: FinanceTypeTable;
}) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [currencies, setCurrencies] = useState([]);
  const [stages, setStages] = useState<NameIdType[]>([]);
  const [sellingStages, setSellingStages] = useState<NameIdType[]>([]);
  const [roles, setRoles] = useState<{ name: string }[]>([]);
  const [financeTypes, setFinanceTypes] = useState<string[]>([]);
  const navigate = useNavigate();
  const dropdownRef = useRef<HTMLDivElement>(null);

  useOutsideClick(dropdownRef, () => setIsOpen(false), isOpen);

  useEffect(() => {
    const loadData = async () => {
      try {
        if (type === DropdownTypeEnum.CURRENCY) {
          const data = await getData(`${API_URL_VALUTA}/get-all`);
          setCurrencies(data);
        }

        if (type === DropdownTypeEnum.STAGE) {
          const data = await getData(
            `${API_URL_PROJECT}/${EndpointsEnum.STAGE}`
          );
          setStages(data);
        }

        if (type === DropdownTypeEnum.PROJECT_ROLES) {
          const data = await getData(`${API_URL_PROJECT}/get-roles`);
          setRoles(data);
        }

        if (type === DropdownTypeEnum.FINANCE_TYPES) {
          const data = await getData(
            `${API_URL_FINANCE}/get-all-type-${financeTableType === FinanceTypeTable.INCOME
              ? "incomes"
              : "expense"
            }`
          );
          setFinanceTypes(data);
        }

        if (type === DropdownTypeEnum.SELLING_STAGE) {
          const data = await getData(
            `${API_URL_SELLING}/get-all-stages`
          );
          setSellingStages(data);
        }
      } catch (err) {
        console.error("Помилка завантаження:", err);
      }
    };

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  return (
    <DropdownStyle
      ref={dropdownRef}
      $type={type}
      $stageProject={!checkedValue ? "" : (checkedValue as StageEnum)}
    >
      <div
        data-type="dropdown-label"
        data-is-open={
          type === DropdownTypeEnum.PROJECT_ROLES && checkedValue
            ? "true"
            : "false"
        }
        onClick={() => {
          if (
            type !== DropdownTypeEnum.CLIENT &&
            type !== DropdownTypeEnum.CONTACT &&
            type !== DropdownTypeEnum.COMPANY &&
            type !== DropdownTypeEnum.MEMBERS &&
            type !== DropdownTypeEnum.PROJECTS &&
            type !== DropdownTypeEnum.SELLINGS
          ) {
            setIsOpen(!isOpen);
          }
        }}
        className={`d-flex align-items-end ${type === DropdownTypeEnum.LANGS && "gap-1"
          }`}
      >
        {type === DropdownTypeEnum.LANGS && (
          <img className="mr-1" src={earthIcon} alt="earth-icon" />
        )}
        {type === DropdownTypeEnum.NUMBERS ? (
          <LittleText>{checkedValue}</LittleText>
        ) : type === DropdownTypeEnum.DATE ? (
          <MediumText>{checkedValue}</MediumText>
        ) : type === DropdownTypeEnum.PERIODS ? (
          <NotificationText>
            {periodsObj[checkedValue as PeriodTypesEnum].text}
          </NotificationText>
        ) : type === DropdownTypeEnum.FINANCE_TYPE ? (
          <NotificationText>
            {checkedValue as FinanceTypeTable}
          </NotificationText>
        ) : type === DropdownTypeEnum.CLIENT ||
          type === DropdownTypeEnum.CONTACT ||
          type === DropdownTypeEnum.COMPANY ||
          type === DropdownTypeEnum.MEMBERS ||
          type === (DropdownTypeEnum.PROJECTS as DropdownTypeEnum) ||
          type === (DropdownTypeEnum.SELLINGS as DropdownTypeEnum) ? (
          <input
            id={type}
            name={type}
            placeholder={
              placeholder ??
              (type === DropdownTypeEnum.COMPANY
                ? "Введіть назву компанії"
                : "Введіть пошту / ім’я")
            }
            onFocus={() => setIsOpen(true)}
            value={checkedValue}
            onChange={(e) => {
              setChecked(e.target.value);
            }}
            autoComplete={type}
          />
        ) : type === DropdownTypeEnum.STAGE ? (
          <TextBody>
            {!checkedValue ? "Виберіть статус проекту" : checkedValue}
          </TextBody>
        ) : type === DropdownTypeEnum.SELLING_STAGE ? (
          <TextBody>{!checkedValue ? "Виберіть етап" : checkedValue}</TextBody>
        ) : type === DropdownTypeEnum.FINANCE_TYPES ? (
          <TextBody>{!checkedValue ? placeholder : checkedValue}</TextBody>
        ) : type === DropdownTypeEnum.PROJECT_ROLES ? (
          <TextBody>
            {!checkedValue ? "Виберіть роль учасника" : checkedValue}
          </TextBody>
        ) : (
          <MediumText>
            {type === DropdownTypeEnum.LANGS
              ? checkedValue.toUpperCase()
              : checkedValue}
          </MediumText>
        )}
        {type !== DropdownTypeEnum.CLIENT &&
          type !== DropdownTypeEnum.CONTACT &&
          type !== DropdownTypeEnum.COMPANY &&
          type !== DropdownTypeEnum.MEMBERS &&
          type !== DropdownTypeEnum.PROJECTS &&
          type !== DropdownTypeEnum.SELLINGS && (
            <Arrow
              iconUrl={
                type === DropdownTypeEnum.PANEL_ITEMS
                  ? isOpen
                    ? triangleUpIcon
                    : triangleDownIcon
                  : (type === DropdownTypeEnum.LANGS ||
                    type === DropdownTypeEnum.NUMBERS ||
                    type === DropdownTypeEnum.PERIODS ||
                    type === DropdownTypeEnum.FINANCE_TYPE ||
                    type === DropdownTypeEnum.DATE ||
                    type === DropdownTypeEnum.CURRENCY ||
                    type === DropdownTypeEnum.STAGE ||
                    type === DropdownTypeEnum.SELLING_STAGE ||
                    type === DropdownTypeEnum.FINANCE_TYPES) &&
                    isOpen
                    ? arrowUpIcon
                    : arrowDownIcon
              }
            ></Arrow>
          )}
      </div>
      <DropdownWindow $isOpen={isOpen} $type={type}>
        {type === DropdownTypeEnum.PANEL_ITEMS && (
          <>
            <MediumText data-type="title">Всі категорії:</MediumText>
            {panelItems.slice(0, panelItems.length - 1).map((item, index) => (
              <MediumText
                data-type={checkedValue === item.name ? "active" : ""}
                key={index}
                onClick={() => {
                  setChecked(item.name);
                  setIsOpen(!isOpen);
                }}
              >
                {item.name}
              </MediumText>
            ))}
          </>
        )}
        {type === DropdownTypeEnum.LANGS &&
          langs.map((item, index) => (
            <MediumText
              key={index}
              data-type={checkedValue === item.id ? "active" : ""}
              onClick={() => {
                setChecked(item.id);
                setIsOpen(!isOpen);
              }}
            >
              {item.name}
            </MediumText>
          ))}
        {(type === DropdownTypeEnum.NUMBERS ||
          type === DropdownTypeEnum.DATE) &&
          numberArray!.map((item, index) => (
            <LittleText
              key={index}
              className="ps-2  pe-3"
              // eslint-disable-next-line eqeqeq
              data-type={checkedValue == item ? "active" : ""}
              onClick={() => {
                setChecked(item);
                setIsOpen(!isOpen);
              }}
            >
              {item}
            </LittleText>
          ))}
        {type === DropdownTypeEnum.PERIODS &&
          Object.values(PeriodTypesEnum).map((item, index) => (
            <NotificationText
              key={index}
              data-type={checkedValue.includes(item) ? "active" : ""}
              onClick={() => {
                setChecked(item);
                setIsOpen(!isOpen);
              }}
            >
              {periodsObj[item].text}
            </NotificationText>
          ))}
        {type === DropdownTypeEnum.FINANCE_TYPE &&
          Object.values(FinanceTypeTable).map((item, index) => (
            <NotificationText
              key={index}
              data-type={checkedValue === item ? "active" : ""}
              onClick={() => {
                setChecked(item);
                setIsOpen(!isOpen);
              }}
            >
              {item}
            </NotificationText>
          ))}
        {type === DropdownTypeEnum.CURRENCY &&
          currencies.slice(0, -1).map((item: CurrencyType) => (
            <MediumText
              key={item.id}
              // eslint-disable-next-line eqeqeq
              data-type={checkedValue == item.symbol ? "active" : ""}
              onClick={() => {
                setChecked(item.symbol);
                setIsOpen(!isOpen);
              }}
            >
              {item.name}
            </MediumText>
          ))}
        {((type === DropdownTypeEnum.CLIENT ||
          type === DropdownTypeEnum.CONTACT ||
          type === DropdownTypeEnum.MEMBERS) &&
          contactsArr?.length === 0) ||
          (type === DropdownTypeEnum.COMPANY && companyArr?.length === 0) ||
          (type === DropdownTypeEnum.CLIENT && contactsArr?.length === 0) ||
          (type === DropdownTypeEnum.PROJECTS && itemsNameIdArr?.length === 0) ||
          (type === DropdownTypeEnum.SELLINGS && itemsNameIdArr?.length === 0) ? (
          <div>
            <DropdownDataItem
              firstLabel="Нічого не знайдено"
              subLabel="Спробуйте ще раз"
              onClick={() => {
                setChecked("");
              }}
              btnText="Очистити"
            />
            {![DropdownTypeEnum.CONTACT, DropdownTypeEnum.MEMBERS].includes(
              type
            ) && (
                <DropdownDataItem
                  isAddItem={true}
                  firstLabel=""
                  subLabel="Не знайшли потрібний елемент?"
                  onClick={() => {
                    const linkBody =
                      type === DropdownTypeEnum.COMPANY
                        ? "companies"
                        : type === DropdownTypeEnum.CLIENT
                          ? "clients"
                          : type;

                    navigate(`/${linkBody}/add`);
                  }}
                  btnText="Створити"
                />
              )}
          </div>
        ) : type === DropdownTypeEnum.CLIENT ||
          type === DropdownTypeEnum.CONTACT ||
          type === DropdownTypeEnum.MEMBERS ? (
          contactsArr?.map((item, index) => {
            const isActive: string =
              checkedValue === item.email ? "active" : "";
            return (
              <DropdownDataItem
                key={index}
                firstLabel={item.fullName}
                subLabel={item.email}
                isActive={isActive}
                onClick={() => {
                  if (isActive === "active") setChecked("");
                  else setChecked(item.email);

                  setTimeout(() => setIsOpen(!isOpen), 500);
                }}
                btnText={isActive === "active" ? "Додано" : "Додати"}
              />
            );
          })
        ) : type === DropdownTypeEnum.COMPANY ? (
          companyArr?.slice(0, 5).map((item, index) => {
            const isActive: string = checkedValue === item.name ? "active" : "";
            return (
              <DropdownDataItem
                key={index}
                firstLabel={item.name}
                subLabel={item.responsibleEmail}
                isActive={isActive}
                onClick={() => {
                  if (isActive === "active") setChecked("");
                  else setChecked(item.name);

                  setTimeout(() => setIsOpen(!isOpen), 500);
                }}
                btnText={isActive === "active" ? "Додано" : "Додати"}
              />
            );
          })
        ) : (
          (type === DropdownTypeEnum.PROJECTS ||
            type === DropdownTypeEnum.SELLINGS) &&
          itemsNameIdArr?.slice(0, 5).map((elem, index) => {
            const isActive: string =
              item!.id === elem.id.toString() || item!.id === elem.id
                ? "active"
                : "";
            return (
              <DropdownDataItem
                key={index}
                firstLabel={elem.name}
                subLabel={""}
                isActive={isActive}
                onClick={() => {
                  if (isActive === "active") {
                    setItem!({ name: "", id: "" });
                    setChecked("");
                  } else {
                    setItem!(elem);
                    setChecked(elem.name);
                  }

                  setTimeout(() => setIsOpen(!isOpen), 500);
                }}
                btnText={isActive === "active" ? "Додано" : "Додати"}
              />
            );
          })
        )}
        {type === DropdownTypeEnum.STAGE &&
          stages.map((item) => {
            const isActive: boolean = checkedValue === item.name;
            return (
              <DropdownButtonItem
                key={item.id}
                bgColor={
                  isActive
                    ? stagesObj[item.name as StageEnum]?.bgColor || COLORS.gray
                    : COLORS.gray
                }
                txtColor={
                  isActive
                    ? stagesObj[item.name as StageEnum]?.txColor ||
                    COLORS["bg-text-color"]
                    : COLORS["bg-text-color"]
                }
                brColor={
                  isActive
                    ? stagesObj[item.name as StageEnum]?.bgColor ||
                    COLORS["bg-text-color"]
                    : COLORS["bg-text-color"]
                }
                btnType="large"
                brRadius="24px"
                classes="d-flex justify-content-start"
                clickFunc={() => {
                  setChecked(item.name);
                  setTimeout(() => setIsOpen(!isOpen), 500);
                }}
                value={item.name}
              />
            );
          })}
        {type === DropdownTypeEnum.SELLING_STAGE &&
          sellingStages.map((item) => {
            const isActive: boolean = checkedValue === item.name;
            return (
              <DropdownButtonItem
                key={item.id}
                bgColor={
                  isActive
                    ? sellingStagesObj[item.name as SellingStage]?.bgColor ?? COLORS["light-green"]
                    : COLORS.gray
                }
                txtColor={
                  isActive
                    ? sellingStagesObj[item.name as SellingStage]?.txtColor ?? COLORS.main1
                    : COLORS["bg-text-color"]
                }
                brColor={
                  isActive
                    ? sellingStagesObj[item.name as SellingStage]?.txtColor ?? COLORS.main1
                    : COLORS["bg-text-color"]
                }
                btnType="large"
                brRadius="24px"
                classes="d-flex justify-content-start"
                clickFunc={() => {
                  setChecked(item.name);
                  setTimeout(() => setIsOpen(!isOpen), 500);
                }}
                value={item.name}
              />
            );
          })}
        {type === DropdownTypeEnum.FINANCE_TYPES &&
          financeTypes.map((item) => {
            const isActive: boolean = checkedValue === item;
            return (
              <DropdownButtonItem
                key={item}
                bgColor={isActive ? COLORS["light-gray"] : COLORS.white}
                txtColor={isActive ? COLORS.main2 : COLORS.secondary1}
                brColor={isActive ? `${COLORS.main2} !important` : COLORS.gray}
                btnType="large"
                classes="d-flex justify-content-start"
                clickFunc={() => {
                  setChecked(item);
                  setTimeout(() => setIsOpen(!isOpen), 500);
                }}
                value={item}
              />
            );
          })}
        {type === DropdownTypeEnum.PROJECT_ROLES &&
          roles.map((item) => {
            const isActive: boolean = checkedValue === item.name;
            return (
              <DropdownButtonItem
                key={item.name}
                bgColor={isActive ? COLORS["light-blue"] : COLORS.gray}
                txtColor={isActive ? COLORS.blue : COLORS["bg-text-color"]}
                brColor={isActive ? COLORS.blue : COLORS["bg-text-color"]}
                btnType="large"
                brRadius="24px"
                classes="d-flex justify-content-start"
                clickFunc={() => {
                  setChecked(item.name);
                  setTimeout(() => setIsOpen(!isOpen), 500);
                }}
                value={item.name}
              />
            );
          })}
      </DropdownWindow>
    </DropdownStyle>
  );
}

export const Arrow = styled.span.withConfig({
  shouldForwardProp: (prop) => prop !== "iconUrl" && prop !== "type",
}) <{ iconUrl: string }>`
  display: block;
  background-color: transparent;
  background-size: 100%;
  background-position: center;
  background-image: url(${(props) => props.iconUrl});
  width: 26px;
  height: 26px;
  background-repeat: no-repeat;
  aspect-ratio: 1/1;
  transition: all 400ms cubic-bezier(0.165, 0.84, 0.44, 1);
`;

export const DropdownWindow = styled.div<{
  $isOpen: boolean;
  $type: DropdownTypeEnum;
}>`
  position: absolute;
  ${({ $type }) =>
    $type === DropdownTypeEnum.NUMBERS ||
      // $type === DropdownTypeEnum.STAGE ||
      // $type === DropdownTypeEnum.SELLING_STAGE ||
      $type === DropdownTypeEnum.PROJECT_ROLES ||
      $type === DropdownTypeEnum.MEMBERS
      ? `
        bottom: 100%;
        margin-bottom: ${$type === DropdownTypeEnum.MEMBERS ? "16px" : "8px"};
      `
      : `
        top: 100%;
        margin-top: ${$type === DropdownTypeEnum.PERIODS ||
        $type === DropdownTypeEnum.FINANCE_TYPE
        ? "4px"
        : $type === DropdownTypeEnum.CURRENCY ||
          $type === DropdownTypeEnum.SELLING_STAGE ||
          $type === DropdownTypeEnum.STAGE ||
          $type === DropdownTypeEnum.FINANCE_TYPES
          ? "12px"
          : $type === DropdownTypeEnum.CLIENT ||
            $type === DropdownTypeEnum.CONTACT ||
            $type === DropdownTypeEnum.COMPANY ||
            $type === DropdownTypeEnum.DATE ||
            $type === DropdownTypeEnum.PROJECTS ||
            $type === DropdownTypeEnum.SELLINGS
            ? "16px"
            : "24px"
      };
      `}
  left: ${({ $type }) =>
    $type === DropdownTypeEnum.CLIENT ||
      $type === DropdownTypeEnum.CONTACT ||
      $type === DropdownTypeEnum.COMPANY ||
      $type === DropdownTypeEnum.MEMBERS ||
      $type === DropdownTypeEnum.PROJECTS ||
      $type === DropdownTypeEnum.SELLINGS
      ? "-19px"
      : "0"};
  width: ${({ $type }) =>
    $type === DropdownTypeEnum.PANEL_ITEMS ||
      $type === DropdownTypeEnum.NUMBERS ||
      $type === DropdownTypeEnum.STAGE ||
      $type === DropdownTypeEnum.SELLING_STAGE ||
      $type === DropdownTypeEnum.FINANCE_TYPES ||
      $type === DropdownTypeEnum.DATE
      ? "100%"
      : "auto"};
  background-color: ${({ $type }) =>
    $type === DropdownTypeEnum.CLIENT ||
      $type === DropdownTypeEnum.CONTACT ||
      $type === DropdownTypeEnum.COMPANY ||
      $type === DropdownTypeEnum.MEMBERS ||
      $type === DropdownTypeEnum.PROJECTS ||
      // $type === DropdownTypeEnum.FINANCE_TYPES ||
      $type === DropdownTypeEnum.SELLINGS
      ? COLORS.gray
      : COLORS.white};
  border: 1px solid ${COLORS["bg-text-color"]};
  border-radius: ${({ $type }) =>
    $type === DropdownTypeEnum.CLIENT ||
      $type === DropdownTypeEnum.CONTACT ||
      $type === DropdownTypeEnum.COMPANY ||
      $type === DropdownTypeEnum.MEMBERS ||
      $type === DropdownTypeEnum.PROJECTS ||
      $type === DropdownTypeEnum.FINANCE_TYPES ||
      $type === DropdownTypeEnum.SELLINGS
      ? "12px"
      : "8px"};
  transition: opacity 300ms ease, transform 300ms ease;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transform: ${({ $isOpen, $type }) =>
    $isOpen
      ? "translateY(0)"
      : `translateY(${$type === DropdownTypeEnum.NUMBERS ||
        // $type === DropdownTypeEnum.STAGE ||
        // $type === DropdownTypeEnum.SELLING_STAGE ||
        $type === DropdownTypeEnum.PROJECT_ROLES ||
        $type === DropdownTypeEnum.MEMBERS
        ? "10px"
        : "-10px"
      })`};
  pointer-events: ${({ $isOpen }) => ($isOpen ? "auto" : "none")};
  z-index: 1003;

  display: flex;
  flex-direction: column;
  padding: ${({ $type }) =>
    $type === DropdownTypeEnum.CLIENT ||
      $type === DropdownTypeEnum.CONTACT ||
      $type === DropdownTypeEnum.COMPANY ||
      $type === DropdownTypeEnum.MEMBERS ||
      $type === DropdownTypeEnum.DATE ||
      $type === DropdownTypeEnum.STAGE ||
      $type === DropdownTypeEnum.SELLING_STAGE ||
      $type === DropdownTypeEnum.FINANCE_TYPES ||
      $type === DropdownTypeEnum.PROJECT_ROLES ||
      $type === DropdownTypeEnum.PROJECTS ||
      $type === DropdownTypeEnum.SELLINGS
      ? "6px 10px"
      : "10px 0"};
  ${({ $type }) => [
    ($type === DropdownTypeEnum.STAGE || $type === DropdownTypeEnum.SELLING_STAGE) &&
    `
      ${Button} {
        padding: 8px 24px !important;
        border-width: 1px !important;
      }`,
    $type === DropdownTypeEnum.FINANCE_TYPES &&
    `
      ${Button} {
        padding: 8px 14px !important;
        border-width: 1px;
        border-radius: 20px;
        border-color: ${COLORS["bg-text-color"]};
      }`,
    $type === DropdownTypeEnum.PROJECT_ROLES &&
    `
        ${Button} {
        padding: 4px 32px 4px 16px !important;
        border-width: 2px;
      }`,
  ]}

  ${({ $type }) =>
    ($type === DropdownTypeEnum.DATE ||
      $type === DropdownTypeEnum.FINANCE_TYPES || $type === DropdownTypeEnum.SELLING_STAGE || $type === DropdownTypeEnum.PROJECT_ROLES) &&
    `
    max-height: clamp(140px, 25vh, 220px);
    overflow-y: auto;
    overflow-x: hidden;
    scroll-snap-type: none;
    scrollbar-width: thin;
    overflow-anchor: none;
    scrollbar-color: ${COLORS["bg-text-color"]} transparent;
    transform: translateY(-5px);
    transition: opacity 300ms ease, transform 300ms ease, max-height 300ms ease;
    
    border: 1px solid ${COLORS["bg-text-color"]};

      /* Для Safari / Chrome */
      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: ${COLORS["bg-text-color"]};
        // border-radius: 4px;
        margin-right: 2px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }

      & > * {
      padding: 5px 0;
      font-size: 16px;
      // border-radius: 12px;
      scroll-snap-align: start;
      }
    `}

  ${MediumText}, ${NotificationText} {
    cursor: pointer;
    color: ${COLORS.secondary1};
    width: 100%;
    padding: 4px 16px;
    white-space: nowrap;
    transition: all 100ms ease;
    &:hover {
      background-color: ${COLORS.gray};
    }

    &[data-type="title"] {
      margin: 6px;
      padding: 4px 10px;

      width: 93%;
      border-bottom: 1px solid ${COLORS.secondary1};
      &:hover {
        background-color: transparent;
      }
    }
  }
  ${MediumText}, ${LittleText}, ${NotificationText} {
    &[data-type="active"] {
      background-color: ${COLORS.gray};
      /* font-weight: bolder; */
      color: ${COLORS["bg-text-color"]};
    }
  }
`;

const DropdownStyle = styled.div<{
  $type: DropdownTypeEnum;
  $stageProject?: StageEnum | string;
}>`
  ${({ $type }) => [
    $type === DropdownTypeEnum.NUMBERS &&
    `
      ${Arrow} {
        width: 20px;
        height: 20px;
        padding: 0;
      }
    `,
    $type === DropdownTypeEnum.CURRENCY &&
    `
      padding:0 2px;
      ${Arrow} {
        padding: 0;
      }
    `,
  ]}
  position: relative;
  display: inline-block;
  cursor: pointer;
  width: ${({ $type }) =>
    $type === DropdownTypeEnum.PANEL_ITEMS
      ? "180px"
      : $type === DropdownTypeEnum.CLIENT ||
        $type === DropdownTypeEnum.CONTACT ||
        $type === DropdownTypeEnum.COMPANY ||
        $type === DropdownTypeEnum.MEMBERS ||
        $type === DropdownTypeEnum.STAGE ||
        $type === DropdownTypeEnum.SELLING_STAGE ||
        $type === DropdownTypeEnum.FINANCE_TYPES ||
        $type === DropdownTypeEnum.PROJECTS ||
        $type === DropdownTypeEnum.SELLINGS ||
        $type === DropdownTypeEnum.PROJECT_ROLES
        ? "100%"
        : "auto"};
  img {
    width: 26px;
    height: 26px;
    margin-right: ${({ $type }) => $type === DropdownTypeEnum.LANGS && "4px"};
  }
  div {
    &[data-type="dropdown-label"] {
      transition: all 400ms cubic-bezier(0.165, 0.84, 0.44, 1);
      justify-content: space-between;
      border-radius: ${({ $type }) =>
    $type === DropdownTypeEnum.STAGE ||
      $type === DropdownTypeEnum.SELLING_STAGE ||
      $type === DropdownTypeEnum.FINANCE_TYPES ||
      $type === DropdownTypeEnum.PROJECT_ROLES ||
      $type === DropdownTypeEnum.DATE
      ? "24px"
      : "12px"};
      z-index: -1;
      background-color: ${(props) =>
    props.$type === DropdownTypeEnum.LANGS ||
      props.$type === DropdownTypeEnum.PERIODS ||
      props.$type === DropdownTypeEnum.FINANCE_TYPE
      ? "transparent"
      : props.$type === DropdownTypeEnum.STAGE
        ? !props.$stageProject
          ? "transparent"
          : stagesObj[props.$stageProject as StageEnum].bgColor
        : COLORS.gray};
      ${({ $type, $stageProject }) => [
    $type === DropdownTypeEnum.STAGE &&
    `border: 2px solid ${!$stageProject
      ? COLORS["bg-text-color"]
      : stagesObj[$stageProject as StageEnum].txColor
    };`,
  ]}
      padding: ${({ $type }) =>
    $type === DropdownTypeEnum.NUMBERS
      ? "4px 4px 4px 8px"
      : $type === DropdownTypeEnum.STAGE ||
        $type === DropdownTypeEnum.SELLING_STAGE ||
        $type === DropdownTypeEnum.FINANCE_TYPES
        ? "8px 24px"
        : $type === DropdownTypeEnum.PROJECT_ROLES ||
          $type === DropdownTypeEnum.DATE
          ? "10px 20px"
          : "6px 12px"};
      p {
        color: ${(props) =>
    props.$type === DropdownTypeEnum.STAGE
      ? !props.$stageProject
        ? `${COLORS["bg-text-color"]} !important`
        : stagesObj[props.$stageProject as StageEnum].txColor
      : COLORS.secondary1};
        white-space: nowrap;
      }
    }
    &[data-is-open="true"] {
      background-color: ${COLORS["light-blue"]};
      border-color: ${COLORS.blue};
      p {
        color: ${COLORS.blue};
        font-weight: 600;
      }
    }
  }
  margin-top: ${({ $type }) =>
    $type === DropdownTypeEnum.PROJECT_ROLES ? "8px" : "0px"};

  ${LittleText} {
    color: ${COLORS.secondary1} !important;
  }
`;
